// https://vuetmp.vuejs.org/en/mutations.html

export default {
  // Setters
  setDestinationEmail: (state, payload) => {
    state.general.destinationEmail = payload;
  },
  setReviewRequestFromEmail: (state, payload) => {
    state.templatesReviewRequest.settings.fromEmail = payload;
  },
  setReviewRequestFromName: (state, payload) => {
    state.templatesReviewRequest.settings.fromName = payload;
  },
  setReviewRequestSubject: (state, payload) => {
    state.templatesReviewRequest.settings.subject = payload;
  },
  setReviewRequestPreheader: (state, payload) => {
    state.templatesReviewRequest.settings.preheader = payload;
  },
  setReviewRequestTemplate: (state, payload) => {
    state.templatesReviewRequest = payload;
  },
  setCouponTemplate: (state, payload) => {
    state.templatesCoupon = payload;
  },
  setPhotoRequestTemplate: (state, payload) => {
    state.templatesPhotoRequest = payload;
  },

  setCouponFromEmail: (state, payload) => {
    state.templatesCoupon.settings.fromEmail = payload;
  },
  setCouponEmailFromName: (state, payload) => {
    state.templatesCoupon.settings.fromName = payload;
  },
  setCouponSubject: (state, payload) => {
    state.templatesCoupon.settings.subject = payload;
  },
  setCouponPreheader: (state, payload) => {
    state.templatesCoupon.settings.preheader = payload;
  },
  setReviewRequestSMSFromName: (state, payload) => {
    state.templatesReviewRequestSMS.settings.fromName = payload;
  },
  setReviewRequestHtmlJson: (state, payload) => {
    state.templatesReviewRequest.templateJson = payload.templateJson;
    state.templatesReviewRequest.templateHtml = payload.templateHtml;
  },

  setCouponHtmlJson: (state, payload) => {
    state.templatesCoupon.templateJson = payload.templateJson;
    state.templatesCoupon.templateHtml = payload.templateHtml;
  },
  setVerifyEmailTemplate: (state, payload) => {
    state.templatesVerifyEmail = payload;
  },
  setVerifyEmailHtmlJson: (state, payload) => {
    state.templatesVerifyEmail.templateJson = payload.templateJson;
    state.templatesVerifyEmail.templateHtml = payload.templateHtml;
  },
  setReviewRequestSMSText: (state, payload) => {
    state.templatesReviewRequestSMS.templateJson.text = payload;
    state.templatesReviewRequestSMS.templateHtml = payload.replace(/\n/g, '<br/>');
  },
  setReviewRequestSMSSuccess: (state, payload) => {
    state.newResetDesign = payload.data;
  },
  setReviewRequestSMS: (state, payload) => {
    state.templatesReviewRequestSMS.templateJson.text = payload.data.text;
    state.templatesReviewRequestSMS.templateHtml = payload.data.text.replace(/\n/g, '<br/>');
  },
  setOrderPrinterText: (state, payload) => {
    state.templatesOrderPrinter.templateJson.text = payload;
    state.templatesOrderPrinter.templateHtml = payload;
  },

  // Template
  loadEmailReviewrequestTemplateSuccess: (state, payload) => {
    (state.templatesReviewRequest.templateJson = JSON.parse(payload.data.templateJson)),
      (state.templatesReviewRequest.mergeTags = payload.data.mergeTags);
  },
  loadCountryEmailReviewrequestTemplatesSuccess: (state, payload) => {
    state.templatesReviewRequest.countryEmailAdvancedTemplates = payload.data;
  },
  loadEmailCouponTemplateSuccess: (state, payload) => {
    (state.templatesCoupon.templateJson = JSON.parse(payload.data.templateJson)),
      (state.templatesCoupon.mergeTags = payload.data.mergeTags);
  },
  loadCountryEmailCouponTemplatesSuccess: (state, payload) => {
    state.templatesCoupon.countryEmailAdvancedTemplates = payload.data;
  },
  loadEmailVerifyEmailTemplateSuccess: (state, payload) => {
    (state.templatesVerifyEmail.templateJson = JSON.parse(payload.data.templateJson)),
      (state.templatesVerifyEmail.mergeTags = payload.data.mergeTags);
  },
  loadPageTemplateSuccess: (state, payload) => {
    (state.templatesThxPage.templateJson = JSON.parse(payload.data.templateJson)),
      (state.templatesThxPage.mergeTags = payload.data.mergeTags);
  },
  loadEmailPhotoRequestTemplateSuccess: (state, payload) => {
    (state.templatesPhotoRequest.templateJson = JSON.parse(payload.data.templateJson)),
      (state.templatesPhotoRequest.mergeTags = payload.data.mergeTags);
  },
  loadCountryEmailPhotoRequestTemplateSuccess: (state, payload) => {
    state.templatesPhotoRequest.countryEmailAdvancedTemplates = payload.data;
  },
  loadCountryVerifyEmailRequestTemplateSuccess: (state, payload) => {
    state.templatesVerifyEmail.countryEmailAdvancedTemplates = payload.data;
  },
  loadSMSReviewrequestTemplateSuccess: (state, payload) => {
    (state.templatesReviewRequestSMS.templateJson = JSON.parse(payload.data.templateJson)),
      (state.templatesReviewRequestSMS.mergeTags = payload.data.mergeTags);
  },
  loadOrderPrinterTemplateSuccess: (state, payload) => {
    (state.templatesOrderPrinter.templateJson.text = JSON.parse(payload.data.templateJson).text),
      (state.templatesOrderPrinter.mergeTags = payload.data.mergeTags);
  },

  // Settings - load data
  loadSettingsEmailReviewrequestSuccess: (state, payload) => {
    state.templatesReviewRequest.settings = payload.data;
  },
  loadSettingsEmailReviewrequestCountrySuccess: (state, payload) => {
    state.templatesReviewRequest.countryEmailTemplates = payload.data;
  },
  loadThxPageCountryTemplatesSuccess: (state, payload) => {
    state.templatesThxPage.countryEmailTemplates = payload.data;
  },
  loadSettingsSettingsCouponSuccess: (state, payload) => {
    state.templatesCoupon.settings = payload.data;
  },
  loadSettingsSettingsCouponCountrySuccess: (state, payload) => {
    state.templatesCoupon.countryEmailTemplates = payload.data;
  },
  loadSettingsSmsCountrySuccess: (state, payload) => {
    state.templatesReviewRequestSMS.countryEmailTemplates = payload.data;
  },
  loadSettingsVerifyEmailSuccess: (state, payload) => {
    state.templatesVerifyEmail.settings = payload.data;
  },
  loadSettingsVerifyEmailCountrySuccess: (state, payload) => {
    state.templatesVerifyEmail.countryEmailTemplates = payload.data;
  },
  loadSettingsEmailPhotoRequestSuccess: (state, payload) => {
    state.templatesPhotoRequest.settings = payload.data;
  },
  loadSettingsEmailPhotoRequestCountrySuccess: (state, payload) => {
    state.templatesPhotoRequest.countryEmailTemplates = payload.data;
  },
  loadSettingsSMSReviewrequestSuccess: (state, payload) => {
    state.templatesReviewRequestSMS.settings = payload.data;
  },

  // Settings - send new data
  updateSettingsEmailReviewrequestSuccess: (state, payload) => {
    state.templatesReviewRequest.settings = payload.data.data;
  },
  updateSettingsEmailReviewrequestCountrySuccess: (state, payload) => {
    if (
      state.templatesReviewRequest.countryEmailTemplates.findIndex(
        obj => obj.country === payload.data.data.country
      ) !== -1
    ) {
      // existing country
      state.templatesReviewRequest.countryEmailTemplates[
        state.templatesReviewRequest.countryEmailTemplates.findIndex(
          obj => obj.country === payload.data.data.country
        )
      ] = payload.data.data;
    } else {
      // new country
      state.templatesReviewRequest.countryEmailTemplates.push(payload.data.data);
    }
  },
  updateThxPageCountrySuccess: (state, payload) => {
    if (
      state.templatesThxPage.countryEmailTemplates.findIndex(
        obj => obj.country === payload.data.data.country
      ) !== -1
    ) {
      // existing country
      state.templatesThxPage.countryEmailTemplates[
        state.templatesThxPage.countryEmailTemplates.findIndex(
          obj => obj.country === payload.data.data.country
        )
      ] = payload.data.data;
    } else {
      // new country
      state.templatesThxPage.countryEmailTemplates.push(payload.data.data);
    }
  },
  updateSettingsEmailCouponSuccess: (state, payload) => {
    state.templatesCoupon.settings = payload.data.data;
  },
  updateSettingsEmailCouponCountrySuccess: (state, payload) => {
    if (
      state.templatesCoupon.countryEmailTemplates.findIndex(
        obj => obj.country === payload.data.data.country
      ) !== -1
    ) {
      // existing country
      state.templatesCoupon.countryEmailTemplates[
        state.templatesCoupon.countryEmailTemplates.findIndex(
          obj => obj.country === payload.data.data.country
        )
      ] = payload.data.data;
    } else {
      // new country
      state.templatesCoupon.countryEmailTemplates.push(payload.data.data);
    }
  },
  updateSettingsEmailVerifyEmailSuccess: (state, payload) => {
    state.templatesVerifyEmail.settings = payload.data.data;
  },
  updateSettingsEmailVerifyEmailCountrySuccess: (state, payload) => {
    if (
      state.templatesVerifyEmail.countryEmailTemplates.findIndex(
        obj => obj.country === payload.data.data.country
      ) !== -1
    ) {
      // existing country
      state.templatesVerifyEmail.countryEmailTemplates[
        state.templatesVerifyEmail.countryEmailTemplates.findIndex(
          obj => obj.country === payload.data.data.country
        )
      ] = payload.data.data;
    } else {
      // new country
      state.templatesVerifyEmail.countryEmailTemplates.push(payload.data.data);
    }
  },
  updateSettingsEmailPhotoRequestSuccess: (state, payload) => {
    state.templatesPhotoRequest.settings = payload.data.data;
  },
  updateSettingsEmailPhotoRequestCountrySuccess: (state, payload) => {
    if (
      state.templatesPhotoRequest.countryEmailTemplates.findIndex(
        obj => obj.country === payload.data.data.country
      ) !== -1
    ) {
      // existing country
      state.templatesPhotoRequest.countryEmailTemplates[
        state.templatesPhotoRequest.countryEmailTemplates.findIndex(
          obj => obj.country === payload.data.data.country
        )
      ] = payload.data.data;
    } else {
      // new country
      state.templatesPhotoRequest.countryEmailTemplates.push(payload.data.data);
    }
  },
  updateSettingsSMSReviewrequestSuccess: (state, payload) => {
    state.templatesReviewRequestSMS.settings = payload.data.data;
  },

  // Preview
  loadPreviewReviewrequestSuccess: (state, renderedPreviewTemplate) => {
    state.templatesReviewRequest.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewReviewrequestCountrySuccess: (state, renderedPreviewTemplate) => {
    state.templatesReviewRequest.countryEmailTemplates.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewCouponSuccess: (state, renderedPreviewTemplate) => {
    state.templatesCoupon.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewCouponCountrySuccess: (state, renderedPreviewTemplate) => {
    state.templatesCoupon.countryEmailTemplates.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewVerifyEmailSuccess: (state, renderedPreviewTemplate) => {
    state.templatesVerifyEmail.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewVerifyEmailCountrySuccess: (state, renderedPreviewTemplate) => {
    state.templatesVerifyEmail.countryEmailTemplates.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewPageSuccess: (state, renderedPreviewTemplate) => {
    state.templatesThxPage.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewPhotoRequestSuccess: (state, renderedPreviewTemplate) => {
    state.templatesPhotoRequest.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewPhotoRequestCountrySuccess: (state, renderedPreviewTemplate) => {
    state.templatesPhotoRequest.countryEmailTemplates.previewHTML = renderedPreviewTemplate;
  },
  loadPreviewReviewrequestSMSSuccess: (state, renderedPreviewTemplate) => {
    state.templatesReviewRequestSMS.previewText = renderedPreviewTemplate;
  },
  loadPreviewOrderPrinterSuccess: (state, renderedPreviewTemplate) => {
    state.templatesOrderPrinter.previewText = renderedPreviewTemplate;
  },

  // Save design
  saveDesignReviewRequestSuccess: (state, payload) => {
    state.templatesReviewRequest.templateJson = JSON.parse(payload.data.templateJson);
    state.templatesReviewRequest.previewHTML = payload.data.renderedPreviewTemplate;
    state.saveDesignReviewRequest = payload.data;
  },
  saveDesignReviewRequestCountrySuccess: (state, payload) => {
    state.templatesReviewRequest.countryEmailTemplates.templateJson = JSON.parse(
      payload.data.templateJson
    );
    state.templatesReviewRequest.countryEmailTemplates.previewHTML =
      payload.data.renderedPreviewTemplate;
  },
  saveDesignCouponSuccess: (state, payload) => {
    state.templatesCoupon.templateJson = JSON.parse(payload.data.templateJson);
    state.templatesCoupon.previewHTML = payload.data.renderedPreviewTemplate;
    state.saveDesignCoupon = payload.data;
  },
  saveDesignCouponCountrySuccess: (state, payload) => {
    state.templatesCoupon.countryEmailTemplates.templateJson = JSON.parse(
      payload.data.templateJson
    );
    state.templatesCoupon.countryEmailTemplates.previewHTML = payload.data.renderedPreviewTemplate;
  },
  saveDesignVerifyEmailSuccess: (state, payload) => {
    state.templatesVerifyEmail.templateJson = JSON.parse(payload.data.templateJson);
    state.templatesVerifyEmail.previewHTML = payload.data.renderedPreviewTemplate;
    state.saveDesignVerifyEmail = payload.data;
  },
  saveDesignVerifyEmailCountrySuccess: (state, payload) => {
    state.templatesVerifyEmail.countryEmailTemplates.templateJson = JSON.parse(
      payload.data.templateJson
    );
    state.templatesVerifyEmail.countryEmailTemplates.previewHTML =
      payload.data.renderedPreviewTemplate;
  },
  saveDesignThxPageSuccess: (state, payload) => {
    state.templatesThxPage.templateJson = JSON.parse(payload.data.templateJson);
    state.templatesThxPage.previewHTML = payload.data.renderedPreviewTemplate;
    state.saveDesignThxPage = payload.data;
  },
  saveDesignPhotoRequestSuccess: (state, payload) => {
    state.templatesPhotoRequest.templateJson = JSON.parse(payload.data.templateJson);
    state.templatesPhotoRequest.previewHTML = payload.data.renderedPreviewTemplate;
    state.saveDesignPhotoRequest = payload.data;
  },
  saveDesignPhotoRequestCountrySuccess: (state, payload) => {
    state.templatesPhotoRequest.countryEmailTemplates.templateJson = JSON.parse(
      payload.data.templateJson
    );
    state.templatesPhotoRequest.countryEmailTemplates.previewHTML =
      payload.data.renderedPreviewTemplate;
  },
  saveDesignReviewRequestSMSSuccess: (state, payload) => {
    state.templatesReviewRequestSMS.templateJson = JSON.parse(payload.data.templateJson);
    state.templatesReviewRequestSMS.previewText = payload.data.renderedPreviewTemplate;
    state.saveDesignReviewRequestSMS = payload.data;
  },
  saveReviewRequestSMSSuccessCountry: (state, payload) => {
    if (
      state.templatesReviewRequestSMS.countryEmailTemplates.findIndex(
        obj => obj.country === payload.data.data.country
      ) !== -1
    ) {
      // existing country
      state.templatesReviewRequestSMS.countryEmailTemplates[
        state.templatesReviewRequestSMS.countryEmailTemplates.findIndex(
          obj => obj.country === payload.data.data.country
        )
      ] = payload.data.data;
    } else {
      // new country
      state.templatesReviewRequestSMS.countryEmailTemplates.push(payload.data.data);
    }
  },
  saveDesignOrderPrinterSuccess: (state, payload) => {
    state.templatesOrderPrinter.templateJson = JSON.parse(payload.data.templateJson);
    state.templatesOrderPrinter.previewText = payload.data.renderedPreviewTemplate;
    state.saveDesignOrderPrinter = payload.data;
  },

  // Send test email
  sendDestinationReviewRequestSuccess: (state, payload) => {
    state.destinationEmailReviewRequest = payload;
  },
  sendDestinationCouponSuccess: (state, payload) => {
    state.destinationEmail = payload.data;
  },
  sendDestinationVerifyEmailSuccess: (state, payload) => {
    state.destinationEmail = payload.data;
  },
  sendDestinationPhotoRequestSuccess: (state, payload) => {
    state.destinationEmail = payload.data;
  },

  // Reset template
  sendResetReviewRequestSuccess: (state, payload) => {
    state.newResetDesign = payload.data;
  },
  sendResetCouponSuccess: (state, payload) => {
    state.newResetDesign = payload.data;
  },
  sendResetVerifyEmailSuccess: (state, payload) => {
    state.newResetDesign = payload.data;
  },
  sendResetThxPageSuccess: (state, payload) => {
    state.newResetDesign = payload.data;
  },
  sendResetPhotoRequestSuccess: (state, payload) => {
    state.newResetDesign = payload.data;
  },
  testReviewRequestFlowSuccess: (state, payload) => {
    state.testFlow.reviewRequest = payload.reviewRequestId;
  },
  setReviewRequestTest: (state, payload) => {
    state.testFlow.email = payload.email;
    state.testFlow.products = payload.products;
    state.testFlow.reviewRequest = payload.reviewRequestId;
  },
  resetReviewRequestTest: state => {
    state.testFlow.email = null;
    state.testFlow.products = [];
    state.testFlow.reviewRequest = null;
    state.testFlow.productWidget = null;
  },
  loadReviewRequestTestOrderSuccess: (state, payload) => {
    state.testFlow.reviewRequest = payload.reviewRequest || state.testFlow.reviewRequest;
    state.testFlow.productWidget = payload.productWidget;
  },
};
